import { Navigate, useNavigate, useParams } from 'react-router-dom';
import EditProductDialog from '../../EditProductDialog';
import { showToastError, showToastSuccess } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { editProduct, useProduct } from '../../hooks/useProducts';

export default function EditProductContainer() {
  const navigate = useNavigate();
  const params = useParams();
  const { org } = useLegacyAppSession();
  const productId = String(params.productId || '');
  // History state can outlive an organization switch. Archived products use
  // the same authorized, organization-keyed detail lookup as active products.
  const { data: product, isLoading } = useProduct(org?.id, productId);

  if (!productId) {
    return <Navigate to="/products" replace />;
  }

  if (isLoading) return null;
  if (!product) return <Navigate to="/products" replace />;

  return (
    <EditProductDialog
      productId={productId}
      product={product}
      onClose={() => navigate('/products', { replace: true })}
      onSave={async (updated) => {
        try {
          await editProduct(updated);
          showToastSuccess('Product successfully saved.');
          navigate('/products', { replace: true });
        } catch (error) {
          showToastError('Product could not be saved.');
          console.error(error);
        }
      }}
      onAfterChange={() => navigate('/products', { replace: true })}
      organizationId={org?.id ?? null}
    />
  );
}
